import { FileText, Handshake, Landmark, Lock, Mail, RefreshCcw, ScrollText } from "lucide-react";
import { Link } from "react-router-dom";

const SECTIONS = [
  {
    icon: Handshake, title: "1. مقدمة وقبول الشروط",
    body: "تحدد هذه الاتفاقية شروط استخدام منصة راصد حضوري وأداة متصفح كروم التابعة لها من قبل مدراء المدارس والكوادر التعليمية بالمملكة العربية السعودية. باستخدامك المنصة أو الإضافة فأنت توافق على هذه الشروط كاملة.",
  },
  {
    icon: ScrollText, title: "2. نطاق الخدمة والترخيص",
    body: "المنصة أداة مساعدة إدارية لقراءة بيانات الحضور من منصة حضوري وإعداد التقارير ومسودات خطابات المساءلة، ويبقى تطبيق اللوائح والقرارات الإدارية من مسؤولية إدارة المدرسة وحدها.",
  },
  {
    icon: Landmark, title: "3. خطط الاشتراك والدفع",
    body: "تتضمن الخطط: التجريبي 3 أيام مجاناً، الفصل الدراسي (150 ريالاً)، والعام الكامل (250 ريالاً). يتم الدفع إلكترونياً بالبطاقة (مدى / فيزا / ماستركارد) عبر بوابة Moyasar الآمنة ويُفعَّل الاشتراك تلقائياً فور نجاح الدفع.",
  },
  {
    icon: Lock, title: "4. سرية الحساب والبيانات",
    body: "يلتزم المشترك بالحفاظ على سرية بيانات تسجيل دخوله وعدم مشاركتها، وتتعهد المنصة بعدم استغلال البيانات المستوردة لأي غرض خارج إطار تقديم الخدمة للحساب ذاته.",
  },
  {
    icon: RefreshCcw, title: "5. سياسة الاسترداد والإلغاء",
    body: "نظراً لتوفير فترة تجريبية مجانية كاملة لثلاثة أيام لاختبار المنصة وإضافة كروم، فإن المبالغ المحولة لا تُسترد بعد تفعيل الاشتراك الفصلي أو السنوي إلا في حال وجود خلل تقني تعذر حله.",
  },
  {
    icon: Mail, title: "6. التواصل والدعم القانوني",
    body: "لأي استفسار بشأن هذه الشروط يرجى مراسلتنا عبر البريد المعتمد: rasedhudury@gmail.com — وتخضع هذه الاتفاقية للأنظمة المعمول بها في المملكة العربية السعودية.",
  },
];

export default function Terms() {
  return (
    <div className="min-h-screen bg-[#F8FAF9]" data-testid="terms-page">
      <header className="bg-emerald-950 text-white">
        <div className="max-w-3xl mx-auto px-6 py-10 flex items-center gap-4">
          <div className="w-12 h-12 rounded-2xl bg-emerald-900 border border-emerald-800 flex items-center justify-center shrink-0">
            <FileText className="w-6 h-6 text-amber-400" />
          </div>
          <div>
            <h1 className="text-2xl sm:text-3xl font-bold" data-testid="terms-title">الشروط والأحكام — منصة راصد حضوري</h1>
            <p className="text-sm text-emerald-200/80 mt-1">آخر تحديث: سبتمبر 2026</p>
          </div>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 py-10 space-y-5">
        <p className="text-sm sm:text-base leading-7 text-slate-600 bg-white border rounded-2xl p-5" data-testid="terms-intro">
          تنظم هذه الوثيقة العلاقة بين منصة راصد حضوري ومستخدميها من المدارس والهيئات التعليمية،
          وتشمل استخدام الموقع وإضافة كروم وخدمات الاشتراك والدفع والدعم.
        </p>

        {SECTIONS.map(({ icon: Icon, title, body }, i) => (
          <section key={i} className="bg-white border rounded-2xl p-5 flex gap-4" data-testid={`terms-section-${i}`}>
            <div className="w-10 h-10 rounded-xl bg-emerald-50 border border-emerald-100 flex items-center justify-center shrink-0">
              <Icon className="w-5 h-5 text-emerald-900" />
            </div>
            <div>
              <h2 className="text-base sm:text-lg font-bold text-emerald-950 mb-1.5">{title}</h2>
              <p className="text-sm leading-7 text-slate-600">{body}</p>
            </div>
          </section>
        ))}

        <p className="text-center text-xs text-slate-400 pt-2">
          <Link to="/" className="text-emerald-800 hover:text-emerald-950 font-semibold" data-testid="terms-back-home">العودة للصفحة الرئيسية</Link>
          {" · "}منصة راصد حضوري — نظام تتبع وتقارير الحضور الذكي
        </p>
      </main>
    </div>
  );
}
